import {
  GET_PAYMENT_HISTORY_DONE
} from '../actions';
import assign from 'lodash/assign';

const transformBill = (item) => assign(item, {
    amount: (item.totalcentsdiscounted/100)
});

function paymentsReducer(state = [], action) {
  switch(action.type) {
    case GET_PAYMENT_HISTORY_DONE:
      return action.payload.map(transformBill);
    default:
      return state;
  }
}

export default paymentsReducer;